import {
    StackViewport,
    getEnabledElement
  } from '@cornerstonejs/core';
 
  
  /**
   * It scrolls one slice in the Stack or Volume Viewport, it uses the options provided
   * to determine the slice to scroll to. For Stack Viewport, it scrolls in the 1 or -1
   * direction, for Volume Viewport, it uses the camera and focal point to determine the
   * slice to scroll to based on the spacings.
   * @param viewport - The viewport in which to scroll
   * @param options - Options to use for scrolling, including direction, invert, and volumeId
   * @returns
   */
  export default function seriesScroll(
    viewport,
    options
  ) {
    // check if viewport is disabled then throw error
    const enabledElement = getEnabledElement(viewport.element);
  
    if (!enabledElement) {
      throw new Error('Scroll::Viewport is not enabled (it might be disabled)');
    }
  
    if (
      viewport instanceof StackViewport &&
      viewport.getImageIds().length === 0
    ) {
      throw new Error('Scroll::Stack Viewport has no images');
    }
  
    const { delta } = options;
  
    if (viewport instanceof StackViewport) {
      viewport.scroll(delta, options.debounceLoading, options.loop);
    } else {
      throw new Error(`Not implemented for Viewport Type: StackViewport`);
    }
  }
  